import { API_URL } from "../../../constants";
import * as httpNetworking from "../../../httpNetworking";

const URL = API_URL + "/st/features";
const VERSION = 1;

export type LicenseKeyFeaturesList = Array<{ featureId: string; featureName: string; minVersionXY: string }>;

export default async function getPaidFeatures(): Promise<LicenseKeyFeaturesList> {
    let options: httpNetworking.GETRequestConfig = {
        timeout: 50000
    };

    let response = (await httpNetworking.simpleGETRequest(URL, options, VERSION)).data;
    return response;
}
